import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ComumModule } from '../../../shared/comum.module';
import { RelatorioVeiculoDetalhadoFiltroComponent } from './relatorio-veiculo-detalhado-filtro/relatorio-veiculo-detalhado-filtro.component';
import { RelatorioVeiculoDetalhadoComponent } from './relatorio-veiculo-detalhado.component';
import { RelatorioVeiculoDetalhadoService } from './service/relatorio-veiculo-detalhado.service';

@NgModule({
  imports: [
    CommonModule,
    ComumModule,
    FormsModule,
    BrowserModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    ComumModule,
    ReactiveFormsModule,
    ChartsModule,
    NgbModule
  ],
  providers: [
    RelatorioVeiculoDetalhadoService
  ],
  exports: [
    RelatorioVeiculoDetalhadoComponent
  ],
  declarations: [
    RelatorioVeiculoDetalhadoComponent,
    RelatorioVeiculoDetalhadoFiltroComponent
  ]
})
export class RelatorioVeiculoDetalhadoModule { }
